import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormLocations', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/locations/issue_form_locations.html'),
        controller: 'IssueFormLocationsController',
        controllerAs: 'IssueFormLocationsCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            locations: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/locations/issue_form_locations.component.ts